import React, { Component } from 'react'
import Select from 'react-select'
import CheckBoxField from '../Elements/CheckboxField';
import InputField from '../Elements/InputField';

export default class SlackTab extends Component {
    componentDidMount(){
        const {accounts} = this.props;

         if(accounts && accounts.length>0){
            this.props.onSelect(accounts[0].ConnectedAccounts.id);
         }
    }
    render() {
        const { accounts, tab, checkBox, setCheckBox, onSelect,error,keyword,handleInput,selectAccount,channelError } = this.props;
  
        const options = accounts ? accounts.map((account)=>({label:account.ConnectedAccounts.value2,value:account.ConnectedAccounts.id})) : [];
        return (
            <>
                <div className="row margin-bottom-20 mb-5">
                    <div className="col-md-6 titleLabel">
                        <label className="text-dark-75 font-weight-bolder">Select Channel</label>
                        <Select menuPlacement="auto" classNamePrefix="selectpicker" onChange={(e) => onSelect(e.value)} options={options} value={options[options.findIndex(i => i.value == selectAccount)]}/>
                        {channelError && <span id="feedsslackkeyworderror" className="errorMessage required">This field is required</span>}
                    </div>
                    {tab == "ChannelKeyword" ?
                        <div className="col-md-6 titleLabel keywordSection">
                            <label className="text-dark-75 font-weight-bolder">Keyword</label>
                            <InputField name={"keyword"} className="form-control" placeholder="Enter keyword" value={keyword} onChangeHandler={(e)=>handleInput(e)} />
                            {error && <span id="feedsslackkeyworderror" className="errorMessage required">This field is required</span>}
                        </div>
                        : null}
                </div>
                {checkBox != null ? <div className="form-group hideforBSearch">
                    <div className="checkbox-inline mb-2">
                        <CheckBoxField isChecked={checkBox} onChangeHandler={setCheckBox} name={"moderation"} id={`feedscreatemoderation${tab == "ChannelKeyword" ? '1':''}`} />
                    </div>
                </div> : null}
            </>
        )
    }
}
